(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";

const OutsideClick = _ref => {
  let {
    onClick,
    children
  } = _ref;
  const node = useRef();
  const handleClick = useCallback(e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    } // outside click


    onClick();
  }, [onClick]);
  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]);
  return /*#__PURE__*/React.createElement("div", {
    ref: node
  }, children);
};

__signature__(OutsideClick, "useRef{node}\nuseCallback{handleClick}\nuseEffect{}");

OutsideClick.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

const _default = /*#__PURE__*/React.memo(OutsideClick);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(OutsideClick, "OutsideClick", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/OutsideClick/OutsideClick.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/OutsideClick/OutsideClick.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();